function getVerificationDigit(value: number) {
  const rest = value % 11
  return rest < 2 ? 0 : 11 - rest
}

function sumDigits(first: number, second: number) {
  return first + second
}

function multiplyDigits(factor: number) {
  return function (digit: string, index: number) {
    return Number(digit) * (factor - index)
  }
}

export function extractCpf(maskedCpf: string | null | undefined) {
  if (!maskedCpf) return undefined
  return maskedCpf.replace(/\D/g, '')
}

export function isValidCpf(cpf: string | undefined | null) {
  const brokenCpf = extractCpf(cpf)?.match(/^(\d{9})(\d{2})$/)

  if (!brokenCpf) return false

  const withoutDigits = brokenCpf[1].split('')
  const digits = brokenCpf[2]

  const firstDigit = getVerificationDigit(withoutDigits.map(multiplyDigits(10)).reduce(sumDigits))
  const secondDigit = getVerificationDigit(
    withoutDigits.concat(String(firstDigit)).map(multiplyDigits(11)).reduce(sumDigits)
  )

  return String(firstDigit) + secondDigit === digits
}

export function formatCpf(cpf: string | null | undefined) {
  if (!cpf) return cpf
  return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
}
